import React, { useState, useContext } from 'react';
import Select from 'react-select';
import css from './ContainerSearch.module.css'
import DateSelectRange from '../../../UI/Inputs/DateSelectRange';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle'; 
import Search from "../../../../assets/Icon/Search"; 
 
const ContainerSearch = ({ containerService, isTable, columns, onSearchChange }) => {
  const { appState, app } = useContext(AppContext);
  const [currentTab, setCurrentTab] = useState(1)

   const shippers = appState.shippers.map((shipper) => ({ value: shipper.id, label: shipper.name }));
   const marines = appState.marines.map((shipper) => ({ value: shipper.id, label: shipper.name }));
 
    const customFilers = [
    { value: 1, label: "კომპანიის დავალიანება" },
    { value: 2, label: "კლიენტის დავალიანება" }, 
  ];
  
    const transits = [
    { value: 1, label: "კი" },
    { value: 2, label: "არა" }, 
  ];
    
  const greens = [
    { value: 1, label: "გამწვანებული (კი)" },
    { value: 2, label: "გასამწვანებელი (არა)" },
  ];

  const bl_search = [
    { value: 1, label: "დამატებულია" },
    { value: 2, label: "არაა დამატებული" }, 
  ];


  const price_filter = [
    { value: 1, label: "ფასი დამატებულია კლიენტისთვის" },
    { value: 2, label: "ფასი არაა დამატებული კლიენტისთვის " }, 
    { value: 3, label: "ფასი დამატებულია კომპანიისთვის" },
    { value: 4, label: "ფასი არაა დამატებული კომპანიისთვის " }, 
  ];


  const tabs = [
    { value: 1, label: "აქტიური"  },
    { value: 2, label: "არქივი"},
    { value: 3, label: "წაშლილები"},
  ];

 
  const handleInputChange = (event) => {
    const { name, value } = event.target;
 
    containerService.setFilter({
      ...containerService.filter,
      [name]: value,
      page: 1,
    });
 

    if(event.target.name == "search"){
      
        onSearchChange(event.target.value);

    }

  };

  const onChangeTab = (val) => {


 

    setCurrentTab(val.value)
     switch (val.value) {
      case 1:
        containerService.setFilter(prevState => ({ 
          ...prevState,
          is_archive: false,
          is_deleted: false,
        }));
        break;
      case 2:
        containerService.setFilter(prevState => ({ 
          ...prevState,
          is_archive: true,
          is_deleted: false,
        }));
        break;
      case 3:
        containerService.setFilter(prevState => ({ 
          ...prevState,
          is_archive: false,
          is_deleted: true,
        }));
        break;
      default:
        containerService.setFilter(prevState => ({ 
          ...prevState,
          is_archive: false,
          is_deleted: false,
        }));    }
  }


  const hanldeSendMinMax = (startDate, endDate) => {
    containerService.setFilter({
      ...containerService.filter,
      send_at_min: startDate ? startDate : "",
      send_at_max: endDate ? endDate : "",
    });
  };

  const hanldeEntry_atMinMax = (startDate, endDate) => {
    containerService.setFilter({
      ...containerService.filter, 
      entry_at_min: startDate ? startDate : "",
      entry_at_max: endDate ? endDate : "",
    });
  };

 
  const hanldeCreatedMinMax = (startDate, endDate) => {
    containerService.setFilter({
      ...containerService.filter, 
      created_at_min: startDate ? startDate : "",
      created_at_max: endDate ? endDate : "",
    });
  };
 
  const hanldeOpen_atMinMax = (startDate, endDate) => {
    containerService.setFilter({
      ...containerService.filter, 
      open_at_min: startDate ? startDate : "",
      open_at_max: endDate ? endDate : "",
    });
  };
 
  const hanldeTaken_atMinMax = (startDate, endDate) => {
    containerService.setFilter({
      ...containerService.filter, 
      taken_at_min: startDate ? startDate : "",
      taken_at_max: endDate ? endDate : "",
    });
  };
 

  const [isActive, setIsActive] = useState(false);

  const handleSearchClick = () => {
    setIsActive(!isActive);
  };
 

 
  return (

    <>
       
      <div className={css.searchBTN} onClick={handleSearchClick}>  
          <span className={css.icon}> <Search /></span>
          <span>ძებნა</span> 
      </div>
 
      <div className={isActive ? css.overlayBG +' '+ css.active  : css.overlayBG} onClick={handleSearchClick}></div>



      <div  className={isActive ? css.mainSearch +' '+ css.active  : css.mainSearch} >

          <div className={css.searchBox + ' ' + css.searchBoxFirst }>
      
              <div className={css.col } style={{flex: 1, borderLeft: '1px solid transparent' }}>
                <div className={css.groupInput} >
                    <div className={css.groupInputIcon}>
                    <input
                        name="search"
                        className={css.input}
                        placeholder="VIN, ინვოისი ან სხვა ..."
                        value={containerService.filter.search}
                        onChange={handleInputChange} 
                    />
                    <div className={css.crmIcon}>
                        <Search />
                    </div>
                    </div>
                </div>
              </div>
      
              <div className={css.col }  >
                <div className={css.inBox}>

                    <Select
                    styles={selectStyle}
                    options={appState.container_statuses}
                    value={appState.container_statuses.find(option => option.value === containerService.filter.status_id)}
                    onChange={(selectedOption) => {
                        containerService.setFilter(prevState => ({
                        ...prevState,
                        status_id: selectedOption ? selectedOption.value : 0,
                        }));
                    }}
                    isClearable
                    placeholder="სტატუსი"
                    /> 
                </div>
              </div>
      
              <div className={css.col}>
                  <div className={css.inBox}> 
                      <Select
                      styles={selectStyle}
                      options={transits}
                      value={transits.find(option => option.value === containerService.filter.is_transit)}
                      onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                          ...prevState,
                          is_transit: selectedOption ? selectedOption.value : 0,
                          }));
                      }}
                      isClearable
                      placeholder="ტრანზიტი"
                      />
                  </div>
              </div>
      
              <div className={css.col}>
                  <div className={css.inBox}> 
                      <Select
                      styles={selectStyle}
                      options={greens}
                      value={greens.find(option => option.value === containerService.filter.green)}
                      onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                          ...prevState,
                          green: selectedOption ? selectedOption.value : 0,
                          }));
                      }}
                      isClearable
                      placeholder="გამწვანებულები"
                      />
                  </div>
              </div>
  
      
              <div className={css.col}>
                  <div className={css.inBox}> 
                      <Select
                      styles={selectStyle}
                      options={bl_search}
                      value={bl_search.find(option => option.value === containerService.filter.bl_search)}
                      onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                          ...prevState,
                          bl_search: selectedOption ? selectedOption.value : 0,
                          }));
                      }}
                      isClearable
                      placeholder="BL ფაილი"
                      />
                  </div>
              </div>
  
      
              <div className={css.col}>
                  <div className={css.inBox}> 
                      <Select
                      styles={selectStyle}
                      options={price_filter}
                      value={price_filter.find(option => option.value === containerService.filter.price_filter)}
                      onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                          ...prevState,
                          price_filter: selectedOption ? selectedOption.value : 0,
                          }));
                      }}
                      isClearable
                      placeholder="კონტეინერის ფასები"
                      />
                  </div>
              </div>
              
              <div className={css.col}>
                <div className={css.inBox}> 
                    <Select
                    styles={selectStyle}
                    options={customFilers}
                    value={customFilers.find(option => option.value === containerService.filter.custom_filter)}
                    onChange={(selectedOption) => {
                        containerService.setFilter(prevState => ({
                        ...prevState,
                        custom_filter: selectedOption ? selectedOption.value : 0,
                        }));
                    }}
                    isClearable
                    placeholder="დავალიანება"
                    />
                </div>
              </div>
      
      
      
          </div>

          <div className={css.searchBox}>

              <div className={css.col} >
                  <div className={css.inBox + ' twomonth'}> 
                      <DateSelectRange
                          defDate={""}
                          onChange={hanldeCreatedMinMax}
                          placeholderText="შექმნა"
                          popperClassName={css.dataContainer}
                          wrapperClassName={css.dataContainer}
                          className={css.input}
                          isClearable
                      /> 
                  </div>
              </div>
      
              <div className={css.col} >
                <div className={css.inBox + ' twomonth'}> 
                    <DateSelectRange
                        defDate={""}
                        onChange={hanldeSendMinMax}
                        placeholderText="გამოსვლა"
                        popperClassName={css.dataContainer}
                        wrapperClassName={css.dataContainer}
                        className={css.input}
                        isClearable
                    /> 
                </div>
              </div>
      
              <div className={css.col} >
                <div className={css.inBox + ' twomonth'}> 
                    <DateSelectRange
                        defDate={""}
                        onChange={hanldeEntry_atMinMax}
                        placeholderText="შემოსვლა"
                        popperClassName={css.dataContainer}
                        wrapperClassName={css.dataContainer}
                        className={css.input}
                        isClearable
                    /> 
                </div>
              </div>
      
      
              <div className={css.col} >
              <div className={css.inBox + ' twomonth'}> 
                  <DateSelectRange
                      defDate={""}
                      onChange={hanldeOpen_atMinMax}
                      placeholderText="გახსნა"
                      popperClassName={css.dataContainer}
                      wrapperClassName={css.dataContainer}
                      className={css.input}
                      isClearable
                  /> 
              </div>
              </div>
      
              <div className={css.col}>
                  <div className={css.inBox}>

                      <Select
                          styles={selectStyle}
                          options={shippers}
                          value={shippers.find(option => option.value === containerService.filter.shipper_id)}
                          onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                              ...prevState,
                              shipper_id: selectedOption ? selectedOption.value : 0,
                          }));
                          }}
                          isClearable
                          placeholder="შიპერი"
                      /> 
                  </div>
              </div>
      
      
              <div className={css.col}>
                  <div className={css.inBox}> 
                      <Select
                          styles={selectStyle}
                          options={marines}
                          value={marines.find(option => option.value === containerService.filter.marine_line_id)}
                          onChange={(selectedOption) => {
                          containerService.setFilter(prevState => ({
                              ...prevState,
                              marine_line_id: selectedOption ? selectedOption.value : 0,
                          }));
                          }}
                          isClearable
                          placeholder="საზღვაო ხაზი"
                      /> 
                  </div>
              </div>
      

              <div className={css.col} >
                <div className={css.inBox}> 
                    <Select 
                    styles={selectStyle}
                    options={tabs}
                    value={tabs.find(option => option.value ===  currentTab)}
                    onChange={onChangeTab}
                    /> 
                </div>
              </div>

      

          </div>

      </div>
  

  </>

);


}
export default ContainerSearch;